import { Component } from 'react'
import { ErrorModal } from './ErrorModal'

export class ErrorComponent extends Component {
  render() {
    return <ErrorModal />
  }
}
